export type DraggingAnswer = {
  value: string;
};

export type GameState = {
  target: number;
  done: number;
};

export const BotoxJarType = "BOTOXJARTYPE";

export type DropAreaType = {
  key: string;
  points: DropPointData[];
  draggingArea: {
    headerText: string;
    titleSrc: string;
    options: { key: string; value: string, imageSrc: string }[];
  };
  initialImage: string;
  targetImage: string;
  className?: string;
  successCount: number;
};

export type DropPointData = {
  key: string;
  correctAnswer: string;
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
};

export const DropPointTarget = 4;

export type DragableItemPosition = { x: number; y: number };

export type DragableItemProps = {
  imgSrc: string;
  dragableItemValue: string;
  setBotoxCount: Function;
  resetGame: Function;
  dragableItemPosition: DragableItemPosition;
  setHintVisability: Function;
  hintVisbility: boolean;
  hide?: boolean
};

export type DropPointProps = {
  onDrop: Function;
  correctAnswer: string;
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;
};

export type DropAreaProps = {
  target: number;
  points: DropPointData[];
  initialImage: string;
  targetImage: string;
  resetCounter: Function;
  isActive: boolean;
  onSuccess: Function;

};

export type UserData = { name: string; };

export type UserPayload = {
  name: string;
  code: string;
  score?: number;
  duration?: number;
  date?: string;
};
